import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

var useSnackAsyncError = function useSnackAsyncError() {
  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var snackAsyncError = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var messageId, callback, errorCallback;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              messageId = _ref.messageId, callback = _ref.callback, errorCallback = _ref.errorCallback;
              _context.prev = 1;
              _context.next = 4;
              return callback();

            case 4:
              _context.next = 10;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              enqueueSnackbar(intl.formatMessage({
                id: messageId
              }), {
                variant: 'error'
              });

              if (errorCallback !== undefined) {
                errorCallback();
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function snackAsyncError(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    snackAsyncError: snackAsyncError
  };
};

export default useSnackAsyncError;